import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Checkbox, Dropdown } from "semantic-ui-react";
import ReactHighcharts from "react-highcharts";
import { formatfbInsightsData } from "../../../actions/utils";

class TotalLikesByLike extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartType: "line",
            showGridLines: true,
        };
    }

    renderDownloadButton() {
        return (
            <Dropdown
                data-html2canvas-ignore="true"
                trigger={<Icon name={"download"} />}
                icon={null}
                className="chart-download-dropdown hideable"
                pointing="top right	">
                <Dropdown.Menu>
                    <Dropdown.Item> CSV </Dropdown.Item>
                    <Dropdown.Item> PNG </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    shouldComponentUpdate(prevProps, prevState) {
        if (prevProps.showInfo != this.props.showInfo) {
            return false;
        } else {
            return true;
        }
    }

    change_graph_type(type) {
        this.setState({
            chartType: type,
        });
    }

    toggleGridLines(d) {
        this.setState({
            showGridLines: d.checked,
        });
    }

    render() {
        let x = this.props.totalPageLikesByLike
            ? formatfbInsightsData(this.props.totalPageLikesByLike, this.props.startDateTime, this.props.endDateTime, "totalLikesByLike")
            : {};
        const pageLikesConfig = {
            plotOptions: {
                line: {
                    marker: {
                        enabled: false,
                    },
                },
                series: {
                    cursor: "pointer",
                    // events: {
                    //     click: (event) => {
                    //         this.showChartsResultsPage(event, 2)
                    //     }
                    // }
                },
            },
            chart: {
                className: "skiptranslate",
                height: 300,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                align: "right",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.state.showGridLines ? 1 : 0,
                minorGridLineWidth: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%H:%M:%S.%L",
                    second: "%H:%M:%S",
                    minute: "%H:%M",
                    hour: "%H:%M",
                    day: "%e %b %Y",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                tickInterval: 24 * 3600 * 1000,
                labels: {
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        color: "#1f2e3d",
                    },
                },
            },
            tooltip: {
                shared: true,
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
            },
            series: [
                //{ color: '#53BEA7', name: 'Total', data: x.totalLikeType.data },
                { color: "#A070CF", name: "Paid", data: x.paidLikeType ? x.paidLikeType.data : [] },
                { color: "#FBD352", name: "Unpaid", data: x.unpaidLikeType ? x.unpaidLikeType.data : [] },
                { color: "#AF388E", name: "Unlike", data: x.unlikeLikeType ? x.unlikeLikeType.data : [] },
            ],
            time: {
                useUTC: true,
            },
        };
        const pageLikesColumnConfig = {
            //renderTo: 'charts-column',
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                },
            },
            chart: {
                height: 300,
                type: "column",
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%H:%M:%S.%L",
                    second: "%H:%M:%S",
                    minute: "%H:%M",
                    hour: "%H:%M",
                    day: "%e %b %Y",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                tickInterval: 24 * 3600 * 1000,
                labels: {
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        color: "#1f2e3d",
                    },
                },
            },
            lang: {
                noData: "No Data.",
            },
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
            },
            legend: {
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                align: "right",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            series: [
                //{ color: '#53BEA7', name: 'Total', data: x.totalLikeType.data },
                { color: "#A070CF", name: "Paid", data: x.paidLikeType ? x.paidLikeType.data : [] },
                { color: "#FBD352", name: "Unpaid", data: x.unpaidLikeType ? x.unpaidLikeType.data : [] },
                { color: "#AF388E", name: "Unlike", data: x.unlikeLikeType ? x.unlikeLikeType.data : [] },
            ],
            time: {
                useUTC: true,
            },
        };

        return (
            <div style={{ background: "#fff" }}>
                <div className="top_buttons" style={{ display: "flex", paddingBottom: "10px", justifyContent: "flex-end" }}>
                    {/* {this.renderDownloadButton()} */}
                    <Checkbox
                        label="Show Grid Lines"
                        checked={this.state.showGridLines}
                        onChange={(e, d) => this.toggleGridLines(d)}
                        className="hideable gridlines"
                    />
                    <Checkbox label="Show Unique" checked={true} disabled className="hideable unique" />
                </div>
                <ReactHighcharts
                    style={{ paddingTop: "4%" }}
                    config={this.state.chartType == "line" ? pageLikesConfig : pageLikesColumnConfig}></ReactHighcharts>
                <div className="row chartToolbar toggle__chartType">
                    <div className="changeType">
                        <span>
                            {" "}
                            <Icon
                                className={this.state.chartType == "pie" ? "active" : ""}
                                onClick={() => this.change_graph_type("pie")}
                                name={"pie chart"}
                            />{" "}
                        </span>
                        <span>
                            <Icon className={this.state.chartType == "bar" ? "active" : ""} onClick={() => this.change_graph_type("bar")} name={"bar chart"} />{" "}
                        </span>
                        <span>
                            <Icon
                                className={this.state.chartType == "line" ? "active" : ""}
                                onClick={() => this.change_graph_type("line")}
                                name={"line chart"}
                            />{" "}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        totalPageLikesByLike: state.fbInsightsReducer.totalPageLikesByLike,
        activeIndex: state.fbInsightsReducer.PageLikesChartsTabIndex,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        // fetchfbInsightsData: () => {
        // 	fetchfbInsightsData(dispatch)
        // }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TotalLikesByLike);
